<template>
  <el-dialog
    :visible.sync="show"
    width="30%"
    title="分布图"
  >
    <div class="re">
      <div ref="map" class="map-wrap" :style="{ height: height }"></div>
    </div>
  </el-dialog>
</template>

<script>
import * as echarts from "echarts";
import { fontSize } from "@/js/utils";

export default {
  props: {
    height: {
      type: String,
      default: "200px",
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    opt: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      myChart: "",
      option: {},
      curJSON: "",
      adList: [],
      list: [],
      area: {},
      show:false
    };
  },

  methods: {
    open(area) {
        this.show = true

      this.area = area;
      fetch(area.area_geo).then((res) => {
        if (res.status === 200) {
          res.json().then((result) => {
            echarts.registerMap(area.name, result);
            this.handlerMap();
          });
        }
      });
    },

    handlerMap() {
      let option = {
        geo: {
          map: this.area.name,
          show: true,
          roam: true,
          label: {
            normal: {
              show: true,
              textStyle: {
                //字体颜色
                color: "#fff",
                fontSize: fontSize(0.12),
              },
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#3a7fd5",
              borderColor: "#0a53e9",
              shadowColor: "#092f8f",
              shadowBlur: fontSize(0.1),
            },
            emphasis: {
              areaColor: "#0a2dae", //悬浮区背景
            },
          },
        },
        series: [
          {
            type: "map",
            map: this.area.name,
            geoIndex: 0,
            aspectScale: 1, //长宽比
            // showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: true, // 是否显示对应地名
                textStyle: {
                  //字体颜色
                  color: "#797979",
                },
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: "#031525",
                borderColor: "#FFFFFF",
              },
              emphasis: {
                areaColor: "#2B91B7",
              },
            },
            animation: false,
            data: [],
          },
        ],
      };
      const chart = this.$refs.map;
      if (chart) {
        this.myChart = this.$echarts.init(chart);
        this.myChart.setOption(option);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.map-wrap {
  width: 400px;
  height: 400px;
}


</style>